import React from "react";
import './DataTableWidget.css';
import DataTable from "react-data-table-component";
import DataTableWidgetPagination from "./DataTableWidgetPagination/DataTableWidgetPagination";
import DataTableCheckboxCell from "./DataTableCheckboxCell/DataTableCheckboxCell";



const customStyles = {
	rows: {
		style: {
			cursor: "pointer",
      "&:hover":{
        backgroundColor: "#efefef",
        fontWeight: 'bold',
        transform: ' translate(0.04%,-0.04%)'
        //,color: 'white'
      }
		}
	},
	headCells: {
		style: {
			paddingLeft: '8px', // override the cell padding for head cells
			paddingRight: '8px',
		},
	},
	cells: {
		style: {
			paddingLeft: '8px', // override the cell padding for data cells
			paddingRight: '8px',
		},
	},
};

export default function DataTableWidget(props){

    const {columns, data, title, handleSelection, selectableRowDisabled,onRowClicked, conditionalRowStyles} = props;
    let clear = ((!data)||(data==null)||(!Array.isArray(data))||(data.length==0))?true:false;
    //console.log('The data on table clear_',clear, data);
    return <DataTable
    title={title}
    columns={columns}
    data={data}
    clearSelectedRows={clear}
    defaultSortFieldID={1}
    pagination
    onRowClicked={onRowClicked}
    selectableRows
    selectableRowsComponent={DataTableCheckboxCell}
    onSelectedRowsChange={handleSelection}
    selectableRowDisabled = { selectableRowDisabled}
    compact={true}
    customStyles={customStyles}
    conditionalRowStyles={conditionalRowStyles}
  />;
}